<section class="careers-page animate-fade-in-up" aria-label="Careers">
    <div class="careers-layout">
        <div class="careers-header">
            <div class="careers-kicker">Careers</div>
            <div class="careers-title">
                Build the Future <br class="careers-title-break" />of Cloud.
            </div>
            <div class="careers-copy">
                Join a global team of deep-tech engineers, architects, and innovators. We are always looking for
                exceptional talent to help enterprise organizations navigate complex digital transformations.
            </div>
        </div>

        <div class="careers-content">
            <div class="careers-open-title">Open Roles</div>

            <div class="roles-grid">
                <article class="role-card">
                    <div class="role-card__left">
                        <div class="role-card__meta">
                            <span class="role-card__badge">Engineering</span>
                            <span class="role-card__location">Remote / Global</span>
                        </div>
                        <div class="role-card__title">Senior Cloud Architect (AWS/Azure)</div>
                    </div>
                    <button type="button" class="role-card__btn">Apply Now</button>
                </article>

                <article class="role-card">
                    <div class="role-card__left">
                        <div class="role-card__meta">
                            <span class="role-card__badge">AI / ML</span>
                            <span class="role-card__location">Bengaluru, India</span>
                        </div>
                        <div class="role-card__title">Machine Learning Engineer</div>
                    </div>
                    <button type="button" class="role-card__btn">Apply Now</button>
                </article>

                <article class="role-card">
                    <div class="role-card__left">
                        <div class="role-card__meta">
                            <span class="role-card__badge">Consulting</span>
                            <span class="role-card__location">London, UK</span>
                        </div>
                        <div class="role-card__title">SAP S/4HANA Migration Consultant</div>
                    </div>
                    <button type="button" class="role-card__btn">Apply Now</button>
                </article>
            </div>

            <div class="careers-cta-box">
                <div class="careers-cta-title">Don't see a perfect fit?</div>
                <div class="careers-cta-copy">
                    We are always eager to connect with brilliant minds. Send your resume and a brief introduction to
                    our talent team.
                </div>
                <a href="mailto:careers@reve.cloud" class="careers-cta-btn">Email careers&#64;reve.cloud</a>
            </div>
        </div>
    </div>
</section>